import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterCTA from './components/NewsletterCTA';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '色彩美学 ColorAesthetics',
    url: 'https://color-aesthetics.com',
    description: '专注于美女网站色彩设计的专业知识平台，提供配色方案、设计技巧、案例分析和行业趋势等内容。',
    sameAs: [
      'https://weixin.qq.com',
      'https://weibo.com',
      'https://xiaohongshu.com',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '色彩美学 - 美女网站色彩设计指南',
    url: 'https://color-aesthetics.com',
    description: '探索美女网站色彩搭配的核心技巧，从配色方案到视觉层次，帮助设计师打造高颜值、高转化的美女类网站，提升用户留存与品牌形象。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://color-aesthetics.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '美女网站色彩设计指南 - 首页',
    description: '美女网站色,美女网站配色,网站色彩设计,美女类网站设计,网站配色方案,视觉设计技巧,女性网站UI设计',
    url: 'https://color-aesthetics.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '色彩美学',
      url: 'https://color-aesthetics.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterCTA />
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
    </>
  );
}